
import { STORAGE_KEYS } from "../config/constants";
import { FavoritesAPI } from "../services/api/favorites";
import { isJSON } from "./isJSON";

class FavoriteManager {
	instance = null;
	async add({ bookId }) {
		throw new Error("Not implemented");
	}

	async remove({ bookId }) {
		throw new Error("Not implemented");
	}

	async removeAll() {
		throw new Error("Not implemented");
	}
	static getInstance() {
		if (!this.instance) {
			this.instance = new this();
		}
		return this.instance;
	}
}

export class localStorageFavorites extends FavoriteManager {
	_localStorage_KEY = STORAGE_KEYS.favorite_books_ids;

	constructor() {
		super();
	}

	async _getFavoritesIds({ user }) {
		const data = localStorage.getItem(this._localStorage_KEY);
		if (!user) return [];
		if (!data) return [];
		if (!isJSON(data)) return [];
		const userData = JSON.parse(data)?.[user];
		if (Array.isArray(userData)) return userData;
		return [];
	}

	async add({ bookId, user }) {
		try {
			let favs = await this._getFavoritesIds({ user });
			const exists = favs.some((id) => id === bookId);
			if (exists) return;
			favs = [...favs, bookId];
			localStorage.setItem(
				this._localStorage_KEY,
				JSON.stringify({
					...JSON.parse(localStorage.getItem(this._localStorage_KEY)),
					[user]: favs,
				})
			);
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async remove({ bookId, user }) {
		try {
			let favs = await this._getFavoritesIds({user});
			favs = [...favs].filter((id) => id !== bookId);
			localStorage.setItem(
				this._localStorage_KEY,
				JSON.stringify({
					...JSON.parse(localStorage.getItem(this._localStorage_KEY)),
					[user]: favs,
				})
			);
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}

	async removeAll() {
		try {
			localStorage.removeItem(this._localStorage_KEY);
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
}

export class UserAccountFavorites extends FavoriteManager {
	constructor() {
		super();
	}

	async add({ bookId }) {
		try {
			await FavoritesAPI.add({ bookId });
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
	async remove({ bookId }) {
		try {
			await FavoritesAPI.remove({ bookId });
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}

	// NO IMPLEMENTADO EN EL BACKEND, SIN USO.
	async removeAll() {
		try {
			return Promise.resolve(true);
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
